module.exports = __webpack_public_path__ + "static/img/6.17a077f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mentmo/5/6.png
// module id = olKK
// module chunks = 0